/* eslint-disable no-undef */
import { getApiVersion, http } from '../utils/domain'
// import { parseFormDefs } from '../utils/transformers'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}`
}

/**
 * 中译英/英译中 或者翻译其他语言
 * @param {*} sourceLanguage 原始语言
 * @param {*} targetLanguage 目标语言
 * @param {*} text 要翻译的内容
 * @returns
 */
export const translateTwoLanguages = (sourceLanguage, targetLanguage, text) => {
  return http()
    .post(`${getApiVersion()}/handz/translate/translateBetweenTwoLanguages`, {
      text,
      sourceLanguage,
      targetLanguage,
    })
    .text()
}

/**
 * excel上传解析
 * @param {number} appId
 * @returns
 */
export const excelImport = (appId, formData) => {
  return http()
    .post(`${prefix(appId)}/excelImport`, null, {
      throwHttpErrors: false,
      body: formData,
    })
    .json()
}
